import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { AuthorizationConfiguration } from '../model/classes/authorizationConfiguration.class';

@Injectable()
export class AuthorizationConfigurationService {
    private serviceUrl = 'api/authorizationConfiguration';

    constructor(private http: Http, private sxHttp: SxHttpService) { }

    getAll(systemCode: string, businessCode: string): Observable<AuthorizationConfiguration[]> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}`;

        return this.sxHttp.get(url).map(response => {
            const configurations = response.json().data;
            return configurations.map(configuration => configuration as AuthorizationConfiguration);
        });
    }

    get(systemCode: string, businessCode: string, id: number): Observable<AuthorizationConfiguration> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/${id}`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data as AuthorizationConfiguration);
    }

    disable(systemCode: string, businessCode: string, id: number): Promise<Boolean> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/disable/${id}`;
        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(result => result.json().data as Boolean);
    }

    clearApiTokens(subscriptionCode: string, channelCode: string): Promise<Boolean> {
        const url = `${this.serviceUrl}/${subscriptionCode}/${channelCode}/ClearApiTokens`;
        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(result => result.json().data as Boolean);
    }

    enable(systemCode: string, businessCode: string, id: number): Promise<Boolean> {
        const url = `${this.serviceUrl}/${systemCode}/${businessCode}/enable/${id}`;
        return this.sxHttp
            .put(url, null)
            .toPromise()
            .then(result => result.json().data as Boolean);
    }

    generateApiKey(configuration: AuthorizationConfiguration): Promise<string> {
        const url = `${this.serviceUrl}/GenerateApiKey`;
        return this.sxHttp
            .post(url, configuration)
            .toPromise()
            .then(result => result.json().data as string);
    }

    save(configuration: AuthorizationConfiguration): Promise<AuthorizationConfiguration> {
        const url = `${this.serviceUrl}`;

        return this.sxHttp
            .post(url, configuration)
            .toPromise()
            .then(response => response.json().data as AuthorizationConfiguration);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/authorizationConfiguration.service.ts